export default "__VITE_ASSET__CkXHrLBE__"